import { render } from "./DealerSettings.vue?vue&type=template&id=5b3b50d6&scoped=true"
import script from "./DealerSettings.vue?vue&type=script&lang=js"
export * from "./DealerSettings.vue?vue&type=script&lang=js"

import "./DealerSettings.vue?vue&type=style&index=0&id=5b3b50d6&scoped=true&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3b50d6"]])

export default __exports__